import { render, staticRenderFns } from "./details-content-kyc.vue?vue&type=template&id=9e82e8e6&scoped=true&"
import script from "./details-content-kyc.vue?vue&type=script&lang=js&"
export * from "./details-content-kyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e82e8e6",
  null
  
)

export default component.exports